/*
 *
 * OrderDetails constants
 *
 */

export const DEFAULT_ACTION = '/OrderDetails/DEFAULT_ACTION';



// WEBPACK FOOTER //
// client/containers/OrderDetails/constants.js